import React from "react";
import Badge, { Color } from "../../../../components/atoms/Badge";

import { PartnerBosRepairStatuses } from "../../../../shared/enums";

interface Props {
  status?: PartnerBosRepairStatuses;
}
const RepairStatusBadge: React.FC<Props> = ({ status }) => {
  let kor = "";
  let color: Color = "purple";
  switch (status) {
    case PartnerBosRepairStatuses.RESERVATION_COMPLETED:
      kor = "예약확정";
      color = "green";
      break;
    case PartnerBosRepairStatuses.PAYMENT_COMPLETED:
      kor = "예약신청";
      color = "yellow";
      break;
    case PartnerBosRepairStatuses.COMPLETED:
      kor = "작업완료";
      color = "purple";
      break;
    case PartnerBosRepairStatuses.CANCELED_ORDER:
      kor = "예약취소";
      color = "gray";
      break;
    default:
      kor = "";
      break;
  }
  return kor ? <Badge color={color}>{kor}</Badge> : <>-</>;
};
export default RepairStatusBadge;
